import { useEffect, useRef } from 'react';

interface IUseResetReturnedFromDetailViewOnUnmount {
  isReturnedFromChildPath: boolean;
  onResetReturnedFromDetailView: () => void;
}

export const useResetReturnedFromDetailViewOnUnmount = ({
  isReturnedFromChildPath,
  onResetReturnedFromDetailView,
}: IUseResetReturnedFromDetailViewOnUnmount) => {
  const isReturnedFromChildPathReference = useRef(isReturnedFromChildPath);
  const onResetReturnedFromDetailViewReference = useRef(
    onResetReturnedFromDetailView
  );

  useEffect(() => {
    isReturnedFromChildPathReference.current = isReturnedFromChildPath;
  }, [isReturnedFromChildPath]);

  useEffect(() => {
    onResetReturnedFromDetailViewReference.current =
      onResetReturnedFromDetailView;
  }, [onResetReturnedFromDetailView]);

  useEffect(
    () => () => {
      if (!isReturnedFromChildPathReference.current) {
        onResetReturnedFromDetailViewReference.current();
      }
    },
    []
  );
};
